/**
 * Frontend config. Use env vars prefixed with REACT_APP_.
 * In production, REACT_APP_API_URL is required.
 * In development: default = appels directs vers http://localhost:5001 (pas de proxy, évite 502).
 */
const getEnv = (key: string, fallback: string): string => {
  const v = process.env[key];
  return (v !== undefined && v !== "") ? v.trim() : fallback;
};

const isDev = process.env.NODE_ENV === "development";
const defaultDevApi = "http://localhost:5001";
const rawApiUrl = getEnv("REACT_APP_API_URL", isDev ? defaultDevApi : "http://localhost:5001");
// Ne jamais utiliser l'URL de prod en dev
const API_URL =
  isDev && rawApiUrl.includes("admin-mogadelivery.com") ? defaultDevApi : rawApiUrl;
const defaultWsUrl = API_URL || defaultDevApi;
const WS_URL = getEnv("REACT_APP_WS_URL", defaultWsUrl);

if (process.env.NODE_ENV === "production" && !process.env.REACT_APP_API_URL?.trim()) {
  throw new Error("REACT_APP_API_URL is required in production. Set it in your build environment.");
}

export const config = {
  API_URL,
  WS_URL,
} as const;

export default config;
